import { Route } from "react-router";

import Layout from "./components/layout/Layout"; import DeleteUserPage from "./pages/continente-credentials/tests/DeleteUserPage";
import Tests from "./pages/Tests";

const { fetch: originalFetch } = window;

const cookies: Record<string, string> = {};

async function fetch(
    input: RequestInfo | URL,
    init: RequestInit = {}
): Promise<Response> {
    const cookieNames = Object.keys(cookies);

    if (cookieNames.length > 0) {
        const cookieHeader = cookieNames
            .map((c) => `${c}=${cookies[c]}`)
            .join("; ");

        init.headers = {
            ...init.headers,
            "X-Cookie": cookieHeader,
        };
    }

    const response = await originalFetch(input, init);
    const setCookieHeader = response.headers.get("X-Set-Cookie");

    if (setCookieHeader) {
        setCookieHeader.split(",").map((cookie, index) => {
            const parts = cookie.split("=");
            if (parts.length >= 2) {
                cookies[parts[0]] = parts[1].split(";")[0];
            }
        });
    }
    return response;
}

window.fetch = fetch;

export default function DevApp() {
    return (
        <Layout className="self-center w-[354px] max-[354px]:w-full px-8">
            <Route path="/tests/delete-user" component={DeleteUserPage} />
            <Route path="/tests" component={Tests} />
        </Layout>
    );
}
